// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"pQ-z","carouselContainer":"qQ-z"};